function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#175664}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_7273",
  "data-name": "Group 7273",
  transform: "translate(-2076.309 -8682)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_746",
  "data-name": "Path 746",
  className: "cls-2",
  d: "M693.281 383.894h-14.286a2.935 2.935 0 0 1-2.857-3v-1a2.934 2.934 0 0 1 2.857-3h14.286a2.934 2.934 0 0 1 2.857 3v1a2.935 2.935 0 0 1-2.857 3zm-14.286-5a.978.978 0 0 0-.952 1v1a.979.979 0 0 0 .952 1h14.286a.979.979 0 0 0 .952-1v-1a.978.978 0 0 0-.952-1z",
  transform: "translate(-7452.638 3890.606)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_747",
  "data-name": "Path 747",
  className: "cls-2",
  d: "M693.281 392.894h-14.286a2.935 2.935 0 0 1-2.857-3v-1a2.934 2.934 0 0 1 2.857-3h14.286a2.934 2.934 0 0 1 2.857 3v1a2.935 2.935 0 0 1-2.857 3zm-14.286-5a.978.978 0 0 0-.952 1v1a.979.979 0 0 0 .952 1h14.286a.979.979 0 0 0 .952-1v-1a.978.978 0 0 0-.952-1z",
  transform: "translate(-7452.638 3890.606)"
}));

function SvgActiv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Group_7408",
    "data-name": "Group 7408",
    transform: "translate(8854.809 4418.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6640",
    "data-name": "Rectangle 6640",
    transform: "translate(-8854.809 -4418.5)",
    style: {
      fill: "#fff",
      opacity: 0.003
    },
    d: "M0 0h24v24H0z"
  }), _ref3));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiv);
export default __webpack_public_path__ + "static/media/activ.5fcbb76d.svg";
export { ForwardRef as ReactComponent };